import { useNavigate } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

function PaymentCancelledPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background-50 flex flex-col">
      <Navbar />
      <main className="flex-1 flex items-center justify-center py-20 px-4">
        <div className="max-w-md w-full mx-auto text-center">
          <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-full bg-background-200/70">
            <i className="ri-close-circle-line text-4xl text-foreground-500" />
          </div>
          <h2 className="font-heading font-bold text-xl text-foreground-50 mb-2">
            Paiement annulé
          </h2>
          <p className="text-sm text-foreground-400 mb-6">
            Vous avez annulé le paiement. Votre demande de campagne reste enregistrée dans notre système. Vous pouvez réessayer le paiement ultérieurement ou contacter notre équipe.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <button
              type="button"
              onClick={() => navigate('/ads')}
              className="inline-flex items-center gap-2 px-6 py-2.5 rounded-lg bg-primary-500 text-foreground-950 font-semibold text-sm hover:bg-primary-400 transition-colors whitespace-nowrap"
            >
              <i className="ri-arrow-left-line" />
              Retour aux offres
            </button>
            <button
              type="button"
              onClick={() => navigate('/support')}
              className="inline-flex items-center gap-2 px-6 py-2.5 rounded-lg border border-foreground-300/40 text-foreground-50 font-semibold text-sm hover:bg-foreground-50/10 transition-colors whitespace-nowrap"
            >
              <i className="ri-customer-service-2-line" />
              Contacter le support
            </button>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}

export default PaymentCancelledPage;